import gelaender_waagerecht from './gelaender_waagerecht.png';
import gelaender_hochkant from './gelaender_hochkant.png';
import gelaender_blech from './gelaender_blech.png';
import gelaender_lochblech from './gelaender_lochblech.png';

export const gelaender = [
    {product_img: gelaender_waagerecht, titel: 'Stäbe waagerecht'},
    {product_img: gelaender_hochkant, titel: 'Stäbe hochkant'},
    {product_img: gelaender_blech, titel: 'Blech'},
    {product_img: gelaender_lochblech, titel: 'Lochblech'}
]



